(function ( $ ) {
    $.fn.scrollActive = function() {
      var offsets = [];
      var that = this;
      this.each(function(e) {
        var target = $(this).data('scroll-to');
        var block = $(this).data('scroll-active');
        offsets.push({
          trigger: $(this),
          top: $(target).offset().top,
          height: $(block).outerHeight()
        });
      });
      return $(window).on('scroll', function(e) {
        e.preventDefault();
         var scrollTop = $(this).scrollTop();
         var selected = null;

         offsets.map(function(elem, i) {
           if (Math.floor(elem.top) <= scrollTop && Math.abs(scrollTop - elem.top ) <= elem.height ) {
             selected = elem.trigger;
           }
         });
         if (selected && !selected.hasClass('active')) {
           that.removeClass('active');
           selected.addClass('active');
         }
         if (!selected){
           that.removeClass('active');
         }
      });
    };
}( jQuery ));

$(function() {
    if ($('.js-scroll-active').length) {
        $('.js-scroll-active').scrollActive();
    };
});